(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '../Link', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('../Link'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Link, global.propTypes);
    global.Copyright = mod.exports;
  }
})(this, function (exports, _react, _Link, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _Link2 = _interopRequireDefault(_Link);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Copyright = function (_React$Component) {
    _inherits(Copyright, _React$Component);

    function Copyright() {
      _classCallCheck(this, Copyright);

      return _possibleConstructorReturn(this, (Copyright.__proto__ || Object.getPrototypeOf(Copyright)).apply(this, arguments));
    }

    _createClass(Copyright, [{
      key: 'createLink',
      value: function createLink(link) {
        if (!link.href) {
          return _react2.default.createElement(
            'span',
            null,
            link.text
          );
        }

        return _react2.default.createElement(
          _Link2.default,
          {
            href: link.href,
            style: {
              color: '#777',
              textDecoration: 'none',
              letterSpacing: '1.2px',
              transition: 'all 0.2s ease-in-out'
            },
            hoverStyles: {
              color: '#00a9f2'
            }
          },
          link.text
        );
      }
    }, {
      key: 'renderLinks',
      value: function renderLinks() {
        var _this2 = this;

        return this.props.links.map(function (link, i) {
          return _react2.default.createElement(
            'span',
            { key: i },
            _react2.default.createElement(
              'span',
              null,
              ' | '
            ),
            _this2.createLink(link)
          );
        });
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          'div',
          {
            className: 'copyright-section',
            style: {
              fontSize: '12px',
              color: '#777',
              fontWeight: '100',
              marginBottom: '32px'
            }
          },
          _react2.default.createElement(
            'span',
            null,
            this.props.text && this.props.text.replace('@{year}', new Date().getFullYear())
          ),
          this.renderLinks(),
          ' | ',
          _react2.default.createElement('div', { style: { display: 'inline' }, id: 'teconsent' })
        );
      }
    }]);

    return Copyright;
  }(_react2.default.Component);

  exports.default = Copyright;
  ;

  Copyright.propTypes = {
    text: _propTypes2.default.string,
    links: _propTypes2.default.array
  };

  Copyright.defaultProps = {
    links: []
  };
});